import { TComponentAppearanceSettingConfig } from '@interlayer/js/components/system/TagManager/buzz/types';

export const getCustomPortletStyle = ({
    tags,
    customCSSClassName = ''
}: {
    tags: TComponentAppearanceSettingConfig[];
    customCSSClassName?: string;
}) => {
    const PREFIX = 'customBorder_';

    if (!customCSSClassName.includes(PREFIX) || !tags.length) {
        return {};
    }

    const className = customCSSClassName.split(' ').find((current) => current.includes(PREFIX));
    const tag = tags.find((item) => `${PREFIX}${item.tagName}` === className?.trim());

    return tag?.config || {};
};
